import React, { useEffect, useState } from "react";

function Advancedfilter({   subCategories, setParentFilters }) {
  
  // State for advanced filters
  const [filters, setFilters] = useState({
    steering: "",
    bodyType: "",
    transmission: "",
    modification: "",
    engine: "",
    engineCode: "",
    grade: "",
  });

  // Clear filters function
const clearFilters = () => {
  const reset = {
    steering: "",
    bodyType: "",
    transmission: "",
    modification: "",
    engine: "",
    engineCode: "",
    grade: "",
    subcategoryId: ""
  };

  setFilters(reset);
  setParentFilters(reset);   // IMPORTANT: this triggers API to refetch original results
};




  // Handle filter change and update state
// Handle filter change → update local + parent filters
const handleFilterChange = (e) => {
  const { name, value } = e.target;

  setFilters((prev) => ({
    ...prev,
    [name]: value,
  }));

  setParentFilters((prev) => ({
    ...prev,
    [name]: value,
  }));
};

  // Filter currentParts based on advanced filters
  // const filterParts = () => {
  //   if (!currentParts) return;

  //   let results = currentParts;

  //   Object.keys(filters).forEach((key) => {
  //     if (filters[key]) {
  //       results = results.filter((part) => {
  //         if (!part[key]) return false;

  //         if (Array.isArray(part[key])) {
  //           return part[key].includes(filters[key]);
  //         } else {
  //           return part[key].toString() === filters[key].toString();
  //         }
  //       });
  //     }
  //   });

  //   onResults(results);
  // };

  return (
    <div className="advanced-filter-wrapper">
      <h6 className="mb-4" >Advanced search</h6>


      {/* Clear Filters Button */}
      <button
        type="button"
        className="btn btn-sm btn-secondary mb-3"
        onClick={clearFilters}
      >
        Clear Filters
      </button>
      {/* SUBCATEGORY FILTER */}
{subCategories?.length > 0 && (
  <select
  name="subcategoryId"
  value={filters.subcategoryId}
  onChange={handleFilterChange}
>
  <option value="">All Subcategories</option>

  {subCategories?.map((sub) => (
    <option key={sub._id} value={sub._id}>
      {sub.name}
    </option>
  ))}
</select>
)}


      {/* Advanced Filter Selects */}
      <select
        name="steering"
        value={filters.steering}
        className="form-control mb-2"
        onChange={handleFilterChange}
      >
        <option value="">Steering</option>
        <option value="power steering">Power Steering</option>
        <option value="speed-sensitive steering">Speed-Sensitive Steering</option>
        <option value="four-wheel steering">Four-Wheel Steering</option>
      </select>

      <select
        name="bodyType"
        value={filters.bodyType}
        className="form-control mb-2"
        onChange={handleFilterChange}
      >
        <option value="">Body Type</option>
        <option value="hatchback">Hatchback</option>
        <option value="sedan">Sedan</option>
        <option value="MUV-SUV">MUV-SUV</option>
      </select>

      <select
        name="transmission"
        value={filters.transmission}
        className="form-control mb-2"
        onChange={handleFilterChange}
      >
        <option value="">Transmission Type</option>
        <option value="automatic">Automatic</option>
        <option value="manual">Manual</option>
      </select>

      <select
        name="modification"
        value={filters.modification}
        className="form-control mb-2"
        onChange={handleFilterChange}
      >
        <option value="">Modification</option>
        <option value="GXE10-AEPVK">GXE10-AEPVK</option>
        <option value="JCE15W-AWPVF">JCE15W-AWPVF</option>
        <option value="SXE10-AEAVF">SXE10-AEAVF</option>
      </select>

      <select
        name="engine"
        value={filters.engine}
        className="form-control mb-2"
        onChange={handleFilterChange}
      >
        <option value="">Engine</option>
        <option value="flat engine">Flat Engine</option>
        <option value="v-engine">V-Engine</option>
        <option value="twin-cylinder">Twin-Cylinder</option>
      </select>

      <select
        name="engineCode"
        value={filters.engineCode}
        className="form-control mb-2"
        onChange={handleFilterChange}
      >
        <option value="">Engine Code</option>
        <option value="P1234">P1234</option>
        <option value="P6345">P6345</option>
        <option value="P0987">P0987</option>
      </select>

      <select
        name="grade"
        value={filters.grade}
        className="form-control mb-2"
        onChange={handleFilterChange}
      >
        <option value="">Grade</option>
        <option value="grade1">Grade 1</option>
        <option value="grade2">Grade 2</option>
        <option value="grade3">Grade 3</option>
      </select>
    </div>
  );
}

export default Advancedfilter;
